import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { auth, fireStoreDB } from "./firebaseConfig";
import * as firebaseAuth from "firebase/auth";

export const performLoginThroughFirebase = async ({ email, password }) => {
  try {
    const responseObject = await firebaseAuth.signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return responseObject;
  } catch (error) {
    return error.message;
  }
};

export const performSignUpThroughFirebase = async ({ email, password }) => {
  try {
    const response = await firebaseAuth.createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    return response;
  } catch (error) {
    return error.message;
  }
};

export const performForgetPasswordThroughFirebase = async ({ email }) => {
  try {
    const response = await firebaseAuth.sendPasswordResetEmail(auth, email);
    return response;
  } catch (error) {
    return error.message;
  }
};

export const getDashboardStats = async (type, uid) => {
  const querySnapshot = await getDocs(
    query(
      collection(fireStoreDB, type),
      where("userIds", "array-contains-any", [uid])
    )
  );
  const records = querySnapshot.docs.map((doc) => doc.data());
  return records || [];
};

export const getUserDetails = async (liveUID) => {
  const documentRef = doc(fireStoreDB, `user`, liveUID);
  const res = await getDoc(documentRef);
  return res.data();
};

export const getDashboardDocumentStats = async (type, email) => {
  const querySnapshot = await getDocs(
    query(collection(fireStoreDB, type), where("email", "==", email))
  );
  const records = querySnapshot.docs.map((doc) => doc.data());
  return records || [];
};
